import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import { ViewState } from "@mapmycustomers/shared/types/chat/FieldAgentContext";
import SortModel from "@mapmycustomers/shared/types/viewModel/internalModel/SortModel";

import { UniversalFieldName } from "@app/util/fieldModel/universalFieldsFieldModel";

export type ContextSort = NonNullable<ViewState["sort"]>;

// First entry only; a geoPoint sort is the map's own ordering and means nothing to the agent.
const toContextSort = (sort: SortModel | undefined): ContextSort =>
  (sort ?? [])
    .slice(0, 1)
    // A persisted sort can name a field that no longer resolves.
    .filter(({ field }) => !!field?.sortName && field.sortName !== UniversalFieldName.GEOPOINT)
    .map(({ field, order }) => ({
      direction: order === SortOrder.DESC ? ("desc" as const) : ("asc" as const),
      field: field.sortName,
    }));

export default toContextSort;
